import React from 'react';

import Header from '../../layout/Header.jsx';
import ListParticipations from '../../lists/ListParticipations.jsx';

const PageParticipations = () => (
  <div>
    <Header>Participations</Header>
    <ListParticipations />
  </div>
);

export default PageParticipations;
